import { NewsPost } from './types';
import { QK } from 'ck-queries';
import { fetchWithErrorThrowing, standardDateFormat } from 'ck-utils';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';

export const useNews = (enabled = true) =>
  useQuery({
    queryKey: QK.news.all,
    queryFn: getNews,
    enabled,
  });

export async function getNews(): Promise<NewsPost[]> {
  const res = await fetchWithErrorThrowing('/news-posts', {
    method: 'GET',
  });

  const data: { newsPosts: NewsPost[] } = await res.json();

  return data.newsPosts.map((post) => ({
    ...post,
    createdAtFormatted: dayjs(post.createdAt).format(standardDateFormat),
    updatedAtFormatted: dayjs(post.updatedAt).format(standardDateFormat),
    displayTitle: post.titleSwedish || post.title,
  }));
}
